import React from 'react';
import { useSelector } from 'react-redux';

import { AppState } from 'services/types';
import ListItem from 'components/ListItem';
import {
    FertilizerProductPerUnitType,
    FertilizerProductUnits
} from 'services/fertilizerEvents/types';
import { UnitTypeId } from 'services/unitTypes/types';
import { makeSelectRate } from './selectors';

export interface Props {
    units: FertilizerProductUnits;
    perUnitType: FertilizerProductPerUnitType;
    unitTypeId: UnitTypeId;
}

export default function FertilizerEventRateListItem(
    props: Props
): React.ReactElement {
    const rate = useSelector((state: AppState) =>
        makeSelectRate()(state, props)
    );

    return <ListItem value={rate} description="Rate" />;
}
